const {
    InMemoryCache,
    defaultDataIdFromObject
} = require('apollo-cache-inmemory');

const getFilename = (src) => (src ? src.split('/').pop() : '');

const digest = (object) =>
    `${object.__typename}:${Object.values(object)
        .filter((v) => v !== object.__typename)
        .join('|')}`;

const dataIdFromObject = (object) => {
    const typename = object.__typename;
    switch (typename) {
        /*
        When adding new IDs you must ensure that the format is such that
        it will be globally unique _across the entire schema_ used by SERP

        In addition the object you are making an ID for must not vary based
        on the particular search (e.g. filter counts).
        */

        case 'Badge':
            return `${typename}:${object.name}`;
        case 'HitImage':
            return `${typename}:${getFilename(object.src || object.lowResSrc)}`;
        case 'Coordinates':
        case 'HitSuperlative':
        case 'Details':
            return digest(object);
        default:
            return defaultDataIdFromObject(object);
    }
};

const createCache = () =>
    new InMemoryCache({
        dataIdFromObject
    });

module.exports = {createCache, dataIdFromObject};
